<template>
  <div class="hrTimesheets-section manager-ts-details">
    <div class="hrTimesheets-section-title manager-ts-section-title">Details</div>
    <table class="hrTimesheets-details-table manager-ts-detail-table">
      <tbody>
        <tr class="hrTimesheets-detail-row">
          <td class="hrTimesheets-detail-label">Consultant</td>
          <td class="hrTimesheets-detail-value">
            <div class="hrTimesheets-name-display">
              <span class="hrTimesheets-name-text">{{ partyNameOnly(sheet.consultantName) }}</span>
              <div v-if="consultantIdText" class="hrTimesheets-id-container">
                <span class="hrTimesheets-id-text">({{ consultantIdText }})</span>
                <button
                  type="button"
                  class="hrTimesheets-copy-btn"
                  title="Copy Consultant ID"
                  @click.stop="copyConsultantId"
                >
                  <i class="bi bi-clipboard"></i>
                </button>
              </div>
            </div>
          </td>
        </tr>
        <tr class="hrTimesheets-detail-row">
          <td class="hrTimesheets-detail-label">Type</td>
          <td class="hrTimesheets-detail-value">{{ sheet.consultantType || '—' }}</td>
        </tr>
        <tr class="hrTimesheets-detail-row">
          <td class="hrTimesheets-detail-label">Customer</td>
          <td class="hrTimesheets-detail-value">{{ partyNameOnly(sheet.customerName) }}</td>
        </tr>
        <tr class="hrTimesheets-detail-row">
          <td class="hrTimesheets-detail-label">Vendor</td>
          <td class="hrTimesheets-detail-value">{{ partyNameOnly(sheet.vendorName) }}</td>
        </tr>
        <tr class="hrTimesheets-detail-row">
          <td class="hrTimesheets-detail-label">Period</td>
          <td class="hrTimesheets-detail-value">
            {{ formatIsoToUs(sheet.fromDate) }} – {{ formatIsoToUs(sheet.toDate) }}
          </td>
        </tr>
        <tr class="hrTimesheets-detail-row">
          <td class="hrTimesheets-detail-label">Total hours</td>
          <td class="hrTimesheets-detail-value hrTimesheets-hours-value">{{ sheet.totalHours }}</td>
        </tr>
        <tr class="hrTimesheets-detail-row">
          <td class="hrTimesheets-detail-label">Created</td>
          <td class="hrTimesheets-detail-value">{{ formatCreatedAt(sheet.createdAt) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  partyNameOnly,
  formatIsoToUs,
  formatCreatedAt,
  consultantIdFromSheet
} from '../utils/managerTimesheetCardHelpers';
import '../styles/ManagerTimesheetCardDetails.css';

export default {
  name: 'ManagerTimesheetCardDetails',
  props: {
    sheet: {
      type: Object,
      required: true
    }
  },
  computed: {
    consultantIdText() {
      return consultantIdFromSheet(this.sheet);
    }
  },
  methods: {
    partyNameOnly,
    formatIsoToUs,
    formatCreatedAt,
    async copyConsultantId() {
      const text = this.consultantIdText;
      if (!text) return;
      const label = 'Consultant ID';
      try {
        await navigator.clipboard.writeText(String(text));
        if (this.$toast && typeof this.$toast.success === 'function') {
          this.$toast.success(`${label} copied`);
        }
      } catch {
        try {
          const textArea = document.createElement('textarea');
          textArea.value = String(text);
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          if (this.$toast && typeof this.$toast.success === 'function') {
            this.$toast.success(`${label} copied`);
          }
        } catch {
          window.alert('Could not copy to clipboard.');
        }
      }
    }
  }
};
</script>
